var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgForwardCurve(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8805 7.70815L18.3205 9.14815L13.4405 14.0282L10.1505 10.7382C9.76046 10.3482 9.13046 10.3482 8.74046 10.7382L2.74046 16.7482C2.35046 17.1382 2.35046 17.7682 2.74046 18.1582C3.13046 18.5482 3.76046 18.5482 4.15046 18.1582L9.44046 12.8582L12.7305 16.1482C13.1205 16.5382 13.7505 16.5382 14.1405 16.1482L19.7305 10.5682L21.1705 12.0082C21.4805 12.3182 22.0205 12.0982 22.0205 11.6582V7.35815C22.0305 7.07815 21.8105 6.85815 21.5305 6.85815H17.2405C16.7905 6.85815 16.5705 7.39815 16.8805 7.70815Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardCurve);
export default __webpack_public_path__ + "static/media/forward-curve.101d32e604a3342461dc192d6e48be18.svg";
export { ForwardRef as ReactComponent };